// Supplemental, locally-controlled sections appended to the live upstream
// Terms of Service / Privacy Policy documents (rendered by LegalPage.jsx).
// These cover website-specific clauses the upstream RelayRigs app's Legal
// Center does not yet include. Draft — subject to legal review, same as the
// rest of /legal/*.
export const LEGAL_ADDENDA = {
  "terms-of-service": [
    {
      heading: "Eligibility & Age Restriction",
      body: "You must be at least 18 years old to pre-register, create an account, or otherwise use RelayRigs. By submitting the pre-registration form or creating an account, you represent and warrant that you are 18 years of age or older. RelayRigs does not knowingly permit use of the Platform by anyone under 18.",
    },
    {
      heading: "Limitation of Liability",
      body: "To the fullest extent permitted by law, RelayRigs, its officers, employees, and affiliates will not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Platform. RelayRigs' total liability for any claim arising out of or relating to these Terms will not exceed the total amount you paid to RelayRigs in the twelve (12) months immediately preceding the event giving rise to the claim.",
    },
    {
      heading: "Governing Law & Venue",
      body: "These Terms, and any dispute arising from or relating to them or the Platform, are governed by the laws of the State of Florida, without regard to its conflict-of-laws principles. Any legal action or proceeding arising under these Terms will be brought exclusively in the state or federal courts located in Florida, and you consent to personal jurisdiction there.",
    },
    {
      heading: "Indemnification",
      body: "You agree to indemnify, defend, and hold RelayRigs and its officers, employees, and affiliates harmless from any claims, damages, losses, liabilities, and expenses (including reasonable attorneys' fees) arising out of or related to your use of the Platform, your breach of these Terms, or your violation of any law or the rights of a third party.",
    },
    {
      heading: "Subscription Renewal & Cancellation",
      body: "Paid subscriptions automatically renew monthly until cancelled. You may cancel at any time; cancellation takes effect at the end of the current billing period. See our Refund & Cancellation Policy for details on partial-period refunds.",
    },
    {
      heading: "Communications & Unsubscribing",
      body: "By providing your email or phone number, you consent to receive service-related and, where applicable, marketing communications from RelayRigs. You may unsubscribe from marketing communications at any time via the unsubscribe link included in every email or by contacting support@relayrigs.com. You cannot opt out of essential service, security, or legal notices while you maintain an account or pre-registration.",
    },
    {
      heading: "Copyright / DMCA Policy",
      body: [
        "RelayRigs respects the intellectual property rights of others and responds to notices of alleged copyright infringement that comply with the Digital Millennium Copyright Act (DMCA).",
        "If you believe content on the Platform infringes your copyright, send a written notice to our designated agent at dmca@relayrigs.com including: your signature; identification of the copyrighted work; identification of the allegedly infringing material and its location; your contact information; a statement of good-faith belief the use is unauthorized; and a statement, under penalty of perjury, that the notice is accurate.",
        "A user who believes their content was removed in error may submit a counter-notice to the same address. RelayRigs may terminate the accounts of repeat infringers.",
      ],
    },
  ],
  "privacy-policy": [
    {
      heading: "Age Restriction & Children's Privacy (COPPA)",
      body: "RelayRigs is intended for users 18 years of age or older. We do not knowingly collect personal information from anyone under 18. If we learn we have collected information from a user under 18, we will delete it promptly. Parents or guardians who believe their child has provided us information should contact privacy@relayrigs.com.",
    },
    {
      heading: "What We Collect & How We Use It",
      body: [
        "Account and pre-registration data you provide directly (name, email, phone, company, role, and location).",
        "Anonymous, self-hosted analytics (page views and section engagement) collected only after you accept our cookie banner — no third-party trackers.",
        "We use this data to operate the waitlist, send launch updates, prevent fraud, and improve the Platform.",
      ],
    },
    {
      heading: "No Session Replay or Invasive Tracking",
      body: "RelayRigs does not use third-party session-replay, heatmap-recording, or screen-capture tools. Our analytics are self-hosted, anonymized, and only run after you consent via the cookie banner.",
    },
    {
      heading: "Data Deletion & Retention",
      body: "We do not keep personal data longer than needed for the purpose it was collected, and we stop using it if that purpose changes. Upon a verified deletion request, we erase your personal data within 30 days, except where longer retention is required by law or to resolve an active dispute.",
    },
    {
      heading: "How to Request Deletion or Access",
      body: "Email privacy@relayrigs.com with the subject line \"Data Request\" from the address associated with your pre-registration or account. We will verify your identity and respond within 30 days.",
    },
    {
      heading: "Unsubscribing",
      body: "You can unsubscribe from marketing emails at any time via the link in the email footer or by contacting support@relayrigs.com.",
    },
  ],
};
